export const hcServices = {
  HC: {
    EMPLOYEE_LIST: '/employee/get-list-employee',
    LECTURER_LIST: '/lecturer/get-list-lecturer',
    EMPLOYEE_LECTURER_LIST: '/emplec/get-list'
  }
};
